import * as types from './mutation-types'
import client from '@/base/api/client'

export default {
  login: ({ commit, state }, authInfo) => {
    return client.auth({ data: { auth: { api: 'AuthService.frameShopLogin', input: authInfo } } })
      .then((data) => {
        if (data.auth.output) {
          localStorage.setItem('fs_user', data.auth.output.username)
          localStorage.setItem('fs_user_id', data.auth.output.id)
          localStorage.setItem('fs_token', '2')
          localStorage.setItem('fs_user_role', data.auth.output.role)
          let obj = {
            id: localStorage.getItem('fs_user_id'),
            user: localStorage.getItem('fs_user')
          }
          commit(types.AUTH_LOGIN, obj)
        }
      })
      .catch(err => { throw err })
  },
  logout: ({ commit, state }) => {
    localStorage.removeItem('fs_user')
    localStorage.removeItem('fs_user_id')
    localStorage.removeItem('fs_token')
    localStorage.removeItem('fs_user_role')
    commit(types.AUTH_LOGOUT, null)
    return client.auth({ data: { auth: {api: 'AuthService.frameShopLogout'} } })
  },
  initUser: ({ commit, state }) => {
    return client.auth({ data: { auth: { api: 'AuthService.frameShopGetLoginUser', input: {} } } })
      .then((data) => {
        if (data.auth.output) {
          localStorage.setItem('fs_user', data.auth.output.username)
          localStorage.setItem('fs_user_id', data.auth.output.id)
          localStorage.setItem('fs_token', '2')
          localStorage.setItem('fs_user_role', data.auth.output.role)
          let obj = {
            id: localStorage.getItem('fs_user_id'),
            user: localStorage.getItem('fs_user')
          }
          commit(types.AUTH_LOGIN, obj)
        } else {
          localStorage.removeItem('fs_user')
          localStorage.removeItem('fs_user_id')
          localStorage.removeItem('fs_token')
          localStorage.removeItem('fs_user_role')
          commit(types.AUTH_LOGOUT, null)
        }
        return data.auth.output
      })
  }
}
